module.exports = __webpack_public_path__ + "img/ayhf.451e28b8.jpg";